import ModalContainer from "../../common/ModalContainer";
import { formatMoney } from "../../../features/utils/formatMoney";

function getWalletCurrency(wallet) {
  return wallet?.currency || wallet?.currencyCode || "NGN";
}

function CustomerDetailWalletSelectModal({
  open,
  setOpen,
  wallets = [],
  onSelect,
  title = "Select wallet",
  subTitle = "Choose which wallet to debit",
}) {
  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      title={title}
      subTitle={subTitle}
      childClassname="max-w-[520px]"
    >
      <div className="p-4 flex flex-col gap-2">
        {!wallets?.length ? (
          <p className="text-sm text-[#6D7C94] py-6 text-center">
            No wallets found.
          </p>
        ) : (
          wallets.map((wallet, index) => {
            const currency = getWalletCurrency(wallet);
            return (
              <button
                key={wallet?._id || `${currency}-${index}`}
                type="button"
                onClick={() => {
                  onSelect?.({
                    ...wallet,
                    code: currency,
                    name: wallet?.name || currency,
                    symbol: wallet?.symbol || currency,
                  });
                }}
                className="flex items-center justify-between gap-3 w-full rounded-lg border border-[#E0E0E0] bg-[#F9F9F9] px-4 py-3 text-left hover:border-primary1 hover:bg-[#F0F6FF] transition-colors"
              >
                <div className="flex flex-col gap-0.5 min-w-0">
                  <span className="font-semibold text-sm text-[#1A1A1A]">
                    {currency}
                  </span>
                  {wallet?.name ? (
                    <span className="text-xs text-[#6D7C94]">{wallet.name}</span>
                  ) : null}
                </div>
                <span className="text-sm font-semibold text-primary1 shrink-0">
                  {formatMoney(wallet?.balance || 0, currency)}
                </span>
              </button>
            );
          })
        )}
      </div>
    </ModalContainer>
  );
}

export default CustomerDetailWalletSelectModal;
